import { LFProjectRights } from './lf-project-rights';

export class LFProject {
  id = '';
  text = '';
  shortDescription = '';
  group = '';
  location = '';
  rights = new LFProjectRights();
}
